<template>
    <div class="">
        <section >
            <div class="bg-white  shadow pt-4 row m-0 p-0 " style="z-index: 10000; ">
                <div class="col-md-12  d-flex flex-wrap">
                    <div class="col-md-3">
                        <div class="col-md-12 d-flex ">
                            <div class="  wemalogo"><img src="../../assets/wema-faith/Alatfaithlogo.png" alt=""></div>
                            <!-- <div class="navwema  col-md-12  mt-1">ALAT FAITH</div> -->
                        </div>
                    </div>
                    
                    <div class=" col-md-5 div-none">
                        <div class="col-md-12 justify-content-center d-flex mt-2" >
                            <div class="col-md-3 cursor-pointer">Products</div>
                            <!-- <div class="col-md-3">Resources</div> -->
                            <div class="col-md-3 cursor-pointer">Pricing</div>
                            <div class="col-md-3 cursor-pointer">Support</div>
                        </div>
                    </div>
                    
                    <div class="col-md-4 div-none">
                        <div class="col-md-12 d-flex justify-content-around">
                            <div class="col-md-4 mt-2 cursor-pointer  ">
                                <router-link to="/onboarding" class="text-dark text-decoration-none">
                                    Sign up
                                </router-link>
                            </div>

                            <div class="col-md-4">
                                <router-link to="/login" class="text-decoration-none " >
                                    <button class="churchbtn">Church Login</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class=" col-md-10    toggle text-right " >
                        <div class="col-md-4 " @click="toggleMenu">
                            <i v-if="!navbarText" class="pi pi-bars"></i>
                            <i v-if="navbarText" class="pi pi-times"></i>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-12 d-flex justify-content-end  " >
                    <div class="col-md-3 hoverull w-50  border bg-white shadow-lg pt-2  rounded" :class="{'hide' : !navbarText}"  >
                        <ul>
                            <li class="font-weight-normal cursor-pointer pl-3 pt-3">
                                <router-link to="/login" class="text-decoration-none text-dark ">
                                    Church Login
                                </router-link>
                            </li>
                            <li class="font-weight-normal pl-3 pt-2">
                                <router-link to="/onboarding" class="text-dark text-decoration-none">
                                    Sign up
                                </router-link>
                            </li>
                            <li class=" font-weight-normal pl-3 pt-2">Pricing</li>
                            <li class=" font-weight-normal pl-3 pt-2">Support</li>
                        </ul>
                    </div>
                    
                </div>
            </div>
            <div class="hero container-fluid  container-top mx-0 px-0">
                <!-- <div class="overlay"></div> -->
                <div class=" row justify-content-around ">
                    <div class=" col-md-12 col-lg-5 "  >  
                        <div class="col-text-holder ml-4" >
                            <h1 class="font-weight-bold ">Increase giving <br> Grow your church</h1>
                            <!-- <h1 class="font-weight-bold">Grow your church</h1> -->
                            <p>A range of technology and financial solutions for Churches and other faith-based organizations.</p>
                        </div>
                        <div class="col-logo ml-4" >
                            <h6 class="font-weight-bold  ">Join 11,200 using ALAT Faith solution</h6>
                            <div class="church-logos">
                                <span class="logo"><img src="../../assets/wema-faith/download-1.png" alt=""></span>
                                <span class="logo"><img src="../../assets/wema-faith/winners-logo.png" alt=""></span>
                                <span class="logo"><img src="../../assets/wema-faith/assemblies-of-god-logo.png" alt=""></span>
                                <span class="logo"><img src="../../assets/wema-faith/cgmi1-min-Mask.png" alt=""></span>
                                <span class="logo"><img src="../../assets/wema-faith/cornerstone-bible-church-logo1-1024x1024-1.png" alt=""></span>
                                <span class="logo"><img src="../../assets/wema-faith/insight_bible-church_Mask-2.png" alt=""></span>
                                <span class="logo"><img src="../../assets/wema-faith/Lbbwk7FK_400x400.png" alt=""></span>
                            </div>
                        </div>
                        <div class=" mt-3 ml-4 cursor-pointer" >
                            <router-link to="/onboarding" class=" text-decoration-none">
                                <button class="">SIGN UP FREE <i class="pi pi-chevron-right"></i></button>
                            </router-link>
                        </div>
                    </div>
                    <div class=" col-md-12 col-lg-6 pt-5 d-none d-md-none d-lg-block" style="z-index: 9999; margin-top: 8em">
                        <div class="">
                            <WemaOrbit />
                        </div>
                        <!-- <img src="../../assets/wema-faith/wema-faith-offering-min-1024x817.png" alt=""> -->
                        <!-- <img src="../../assets/wema-faith/wema-faith2.png" alt=""> -->
                    </div>
                </div>
            </div>
        </section>

        <section>
            
            <!-- <div style="display: flex; flex-direction: row;" class="border border-danger container-top py-4"> -->
                <!-- <otp-input
        v-model="token"
        class="style-1 border border-primary w-50"
        size="24"
      ></otp-input> -->
                <!-- <div ref="otpCont">
                    <input
                    type="text "
                    class="digit-box form-control w-100 border border-success"
                    v-for="(el, ind) in digits"
                    :key="el+ind"
                    v-model="digits[ind]"
                    :autofocus="ind === 0"
                    :placeholder="ind+1"
                    maxlength="1"
                    >
                </div> -->
                
                <!-- <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                separator="-"
                :num-inputs="4"
                :should-auto-focus="true"
                :is-input-num="true"
                :conditionalClass="['one', 'two', 'three', 'four']"
                :placeholder="['*', '*', '*', '*']"
                @change="handleOnChange"
                @on-complete="handleOnComplete"
                /> -->
            <!-- </div> -->
            <!-- <button @click="clearInput()">Clear Input</button> -->
            <div class="header-text">
                <h3 class="font-weight-bold">Church Management</h3>
                <p>Automate your entire church administrative processes from membership data management, first-timer follow-up, and church remittance to overall church administration.</p>
            </div>
        </section>

        <section >
            <div class="card1 ">
                <div class="small-card1 shadow-sm py-2">
                    <i class="fa fa-solid fa-user-plus"></i>
                    <h4 class="font-weight-bold">Church Database Management</h4>
                    <p>Build better relationships with members, improve connections and measure performance at any time.</p>
                    <div class="small-card1-btn">
                        <button class="btn">Learn More</button>
                    </div>
                </div>

                <div class="small-card1 shadow-sm  py-2">
                    <i class="fa fa-solid fa-comments "></i>
                    <h4 class="font-weight-bold">Reliable Communication</h4>
                    <p>Communicate important announcements & reminder with member via SMS, Email, WhatsApp & Voice.</p>
                    <div class="small-card1-btn">
                        <button class="btn">Learn More</button>
                    </div>
                </div>

                <div class="small-card1 shadow-sm py-2">
                    <i class="fa fa-solid fa-id-card"></i>
                    <h4 class="font-weight-bold">First Timer Follow System</h4>
                    <p>Automated workflows make sure every visitor receives custom SMS, emails and a follow-up routine.</p>
                    <div class="small-card1-btn">
                        <button class="btn">Learn More</button>
                    </div>
                </div>

                <div class="small-card1 shadow-sm  py-2">
                    <i class="fa fa-solid fa-calculator"></i>
                    <h4 class="font-weight-bold">Church Accounting Solution</h4>
                    <p>An accounting solution (with asset management, reports) customized to suit the needs of churches</p>
                    <div class="small-card1-btn">
                        <button class="btn">Learn More</button>
                    </div>
                </div>
            </div>
        </section>

        <div class="container-fluid bg-image">
            <section>
            <div class="church-website">
                <div class="chruch-website-image">
                    <img src="../../assets/wema-faith/kingscourt-min.png" alt="">
                </div>
                <div class="church-website-text">
                    <div class="website-text">
                    <h3 class="font-weight-bold">Church Websites</h3>
                    <p>a church website should be the foundation of your online communications, a place for people to get authentic information about your church.</p>
                    </div>

                    <!-- <div class="website-sample">
                        <span class="website"><img src="../../assets/wema-faith/caclighthouse-min.jpg" alt=""></span>
                        <span class="website"><img src="../../assets/wema-faith/lovechannels-Premium-min.jpg" alt=""></span>
                        <span class="website"><img src="../../assets/wema-faith/ngcc-church-Premium-min.jpg" alt=""></span>
                        <span class="website"><img src="../../assets/wema-faith/rccgros-Premium-min.jpg" alt=""></span>
                    </div> -->

                    <!-- <div class="web-btn">
                        <router-link to="/onboarding">
                            <button>SIGN UP NOW</button>
                        </router-link>
                    </div> -->
                </div>
            </div>
            </section>

            <section>
                <div class="church-website">
                    
                    <div class="mobile-app-text-col">
                        <div class="mobile-app-text">
                            <h3 class="font-weight-bold">Church Mobile Apps</h3>
                            <p>Stay connected with your community anytime, anywhere with a custom mobile app for your church! Every app is fully integrated with a giving platform and a suite of easy-to-use tools that helps churches to expand their reach and grow their communities. </p>
                        </div>
                        
                        <!-- <div class="mobile-app-sample">
                            <span class="website"><img src="../../assets/wema-faith/rccgtod-app-min.jpg" alt=""></span>
                            <span class="website"><img src="../../assets/wema-faith/dunamis-app-p-min.jpg" alt=""></span>
                            <span class="website"><img src="../../assets/wema-faith/churchplus-pottershouse-min.png" alt=""></span>
                            <span class="website"><img src="../../assets/wema-faith/rccgengagement-app-min.jpg" alt=""></span>
                        </div> -->
                        
                        <!-- <div class="mobile-app-btn">
                            <router-link to="/onboarding">
                                <button>SIGN UP NOW</button>
                            </router-link>
                        </div> -->
                    </div>

                    <div class="chruch-website-image">
                        <img src="../../assets/wema-faith/phone-min.png" alt="">
                    </div>
                </div>
            </section>
    
            <section>
                <div class="church-website">

                    <div class="chruch-website-image online-giving" style="z-index: -9999;">
                        <div class="giv-2">
                            <img src="../../assets/wema-faith/giva-reports-min-1.png" alt="">
                        </div>
                        <div class="giv-1">
                            <img src="../../assets/wema-faith/churchplus-giva-min.png" alt="">
                        </div>
                    </div>
                    
                    <div class="mobile-app-text-col">
                        <div class="mobile-app-text">
                            <h3 class="font-weight-bold">Online Giving</h3>
                            <p class="pl-1">Online Giving provides a convenient way for parishioners to make financial contributions, and it relieves church staff from managing secure bank account information at the same time. Administration is simple and easy. </p>
                        </div>
                        
                        <!-- <div class="online-giving-sample">
                            <ul>
                                <li><i class="fa fa-solid fa-check"></i> Online payment links</li>
                                <li><i class="fa fa-solid fa-check"></i> Multiple channels</li>
                                <li><i class="fa fa-solid fa-check"></i> Recurring giving</li>
                                <li><i class="fa fa-solid fa-check"></i> Comprehensive reports</li>
                                <li><i class="fa fa-solid fa-check"></i> Accept international donations</li>
                            </ul>
                        </div> -->
                        
                        <!-- <div class="online-giving-btn">
                            <router-link to="/onboarding">
                                <button>SIGN UP NOW</button>
                            </router-link>
                        </div> -->
                    </div>
                </div>
            </section>
        </div>
        


        <section>
            <div class="church-website cus-pos">

                <div class="mobile-app-text-col">
                    <div class="mobile-app-text">
                        <h3 class="font-weight-bold">Customized POS</h3>
                        <p class="pl-1">Our Point-of-Sale terminals are designed to serve as alternative means for payment for tithes and offerings, or any other church contribution, transactions can either be local or international. Other solutions on our POS terminals include: </p>
                    </div>
                    
                    <!-- <div class="online-giving-sample">
                        <ul>
                            <li><i class="fa fa-solid fa-check"></i> Customized solutions for Churches</li>
                            <li><i class="fa fa-solid fa-check"></i> USSD on POS</li>
                            <li><i class="fa fa-solid fa-check"></i> Pay With Phone Number</li>
                            <li><i class="fa fa-solid fa-check"></i> Contactless mode of Payments</li>
                        </ul>
                    </div> -->
                    
                    <!-- <div class="online-giving-btn">
                        <router-link to="/onboarding">
                             <button>SIGN UP NOW</button>
                        </router-link>
                       
                    </div> -->
                </div>

                <div class="chruch-website-image">
                    <img src="../../assets/wema-faith/wema-customized-pos.png" alt="">
                </div>

            </div>
        </section>

        <section>
        <div class="omni-channel row">
            <div class="omni-channel-col">
                <div class="omni-channel-text-col">
                    <div class="omni-channel-text">
                        <h3 class="font-weight-bold" >Omni-channel messaging platform: Church SMS, Email, WhatsApp and Voice Solution</h3>
                    </div>
                    
                    <div class="omni-channel-sample">
                        <ul>
                            <li  class="font-weight-bold"><i class="fa fa-solid fa-check"></i> 99.9% Delivery</li>
                            <li class="font-weight-bold"><i class="fa fa-solid fa-check"></i> Instant Sender ID</li>
                            <li class="font-weight-bold"><i class="fa fa-solid fa-check"></i> Automated Messages</li>
                            <li class="font-weight-bold"><i class="fa fa-solid fa-check"></i> Instant Communication</li>
                            <li class="font-weight-bold"><i class="fa fa-solid fa-check"></i> SMS Scheduling</li>
                            <li class="font-weight-bold"><i class="fa fa-solid fa-check"></i> Real-time delivery report analysis.</li>
                        </ul>
                    </div>
                    
                    <!-- <div class="omni-btn">
                        <router-link to="/onboarding">
                            <button>SIGN UP NOW</button>
                        </router-link>
                    </div> -->
                </div>
                <div class="omni-channel-image">
                    <img src="../../assets/wema-faith/features-1-1024x838.png" alt="">
                </div>

            </div>
            </div>
            
        </section>
        <footer>
            <div class="row">
                <ul class="pl-3">
                    <li>Products</li>
                    <li>Company</li>
                    <li>Resources</li>
                    <li>Legal</li>
                    <li>Social links</li>
                </ul>
                <div class="col-md-12">
                    <span class=""><i class="pi pi-facebook"></i></span>
                    <span class="pl-2"><i class="pi pi-instagram"></i></span>
                    <span class="pl-2"><i class="pi pi-twitter"></i></span>
                </div>
            </div>
        </footer>

        
    </div>
</template>

<script>
 import { ref } from "vue";
 import WemaOrbit from "../../components/orbit/wemaOrbit.vue";
// import VOtpInput from 'vue3-otp-input';
export default {
    components: {
        WemaOrbit,
        // VOtpInput,
    },
    setup() {

        const otpInput = ref(null);

    const handleOnComplete = (handle) => {
      console.log('OTP completed: ', handle);
    };

    const handleOnChange = (handleChange) => {
      console.log('OTP changed: ', handleChange);
    };

     const clearInput = () => {
      otpInput.value.clearInput()
    }
        const navbarText = ref(false);

        const toggleMenu = () =>{
            navbarText.value = !navbarText.value
        }

        return{
            navbarText,
            toggleMenu,
            handleOnComplete, handleOnChange, clearInput, otpInput
        }
    },
}
</script>

<style scoped>

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
/* Background colour of an input field with value */
.otp-input.is-complete {
  background-color: #e4e4e4;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input::placeholder {
  font-size: 15px;
  text-align: center;
  font-weight: 600;
}

.Vectorone img {
    width: 60px;
    height: 4rem;
}
.navbar{
    margin-right: -8rem;
}

.bg-image{
    background-image: url('../../assets/wema-faith/background-vector.png');
    background-position: center;
    background-size: cover;
    /* padding: 1px 0; */
}

 .hoverull ul  li a:hover{
    color: #ffffff !important;
    background-color: #900a39;
    font-weight: bolder;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 5px;
    width: 60%;
    transition: all 0.5s ease-in-out;
 }
 .hoverull ul  li:hover{
    color: #ffffff !important;
    background-color: #900a39;
    font-weight: bolder;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 5px;
    width: 60%;
    transition: all 0.5s ease-in-out;
 }

.toggle {
  display: none;
  position: absolute;
  top: -5px;
  left: -40px;
  font-size: 30px;
}
.hide{
    display: none;
    /* background-color: white; */
  }

.toggle:hover {
  cursor: pointer;
}

.shadow{
    box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.2) ;
    /* z-index: 999; */
    height: 105px;
    position: fixed;
    top: 0;
    width: 100%
}

.churchbtn{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    gap: 10px;
    width: 152px;
    height: 43px;
    background: #900a39;
    border-radius: 5px;
}

.wemalogo img{
    width: 80px;
    height: 3.5rem;
}
.wemalogo2 img{
    width: 65px !important;
    height: 4rem;
}
.navwema{
    font: normal normal 800 24px Nunito sans  !important;
    /* width: 155px; */
    height: 28px;
    font-style: normal;
    line-height: 28px;
    color: #900a39;
}
/* *{
    font-family: 'Nunito Sans', sans-serif;
    margin: 0;
    padding: 0;
    
} */
.hero {
    height: 100vh;
    /* background-image: url('../../assets/wema-faith/wema-church-scaled.jpg'); */
    /* background-image: url('../../assets/wema-faith/herobground.png'); */
    background-color: #EDF2FF;
    background-position: center;
    background-size: cover;
    margin-top: 6em;
    padding: 5em 1em 1em;
}

.container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    margin: 0 auto;
    gap: 50px;
}

.col-text {
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 50%;
}

.col-image {
    width: 50%;
}

.col-text-holder h1 {
    font-size: 3em;
    color: #900a39;
    margin-bottom: 0.5rem;
    line-height: 58px;
}

.col-text-holder h5 {
    font-size: 1em;
    line-height: 16px;

}

.col-text-holder p {
    font-size: 1em;
    /* line-height: 30px; */
}

.col-image img {
    width: 100%;
}
.col-logo {
    display: flex;
    flex-direction: column;
    gap: 20px;
    /* margin-bottom: 0.5rem; */
}

.church-logos{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 20px;

}
.church-logos .logo {
    width: 35px;
}

.logo img {
    width: 100%;
}

button{
    padding: 1rem 1.5rem;
    background-color: #900a39;
    color: #fff;
    font-size: .8em;
    line-height: 15px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    font-weight: 700;
}


/* Body Heading section */

.header-text {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    margin: 4em 2em;
}

 h3 {
    font-size: 2rem;
    color: #900a39;
}

.header-text p {
    font-size: 1rem;
    width: 58%;
    text-align: center;
}


/* Card section */

.card1 {
    width: 80%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
}

.small-card1 {
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 15px;
    padding: 0.2rem;
    border: 0.5px solid #900a3927;


}

.small-card1 .fa-solid {
    color: #900a39;
    font-size: 2.2rem;
}

.small-card1 img {
    background-color: #900a39;
}

.small-card1 h4 {
    text-align: center;
    font-size: 1.3rem;
    line-height: 22px;
}
.small-card1 p {
    text-align: center;
    font-size: 0.9rem;
    line-height: 26px;
}

 .btn{
    padding: 0.5rem 1rem;
    background-color: transparent;
    color: #900a39;
    font-size: 1em;
    line-height: 19px;
    border: 1px solid #900a39;
    border-radius: 3px;
    cursor: pointer;
}

.btn:hover {
    background-color: #900a39;
    color: #fff;
}


/* Websites Section */

.church-website {
    display: flex;
    align-items: center;
    gap: 40px;
    width: 80%;
    margin: 0 auto;
    margin-bottom: 7rem;
    margin-top: 7rem;
}

.website-sample, .mobile-app-sample {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    margin: 2.5rem 0;
}

.website-text, .web-btn{
    padding-left: 3rem;
}

.chruch-website-image {
    width: 100%;
}

.chruch-website-image img, .website img {
    width: 100%;
}


.website-text p, .mobile-app-text p {
    font-size: 0.9rem;
    line-height: 21px;

}

.website {
    width: 100px;
}

.mobile-app-text-col {
    width: 96%;
}


/* Omni-channel section */

.omni-channel-col {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 80%;
    margin: 0 auto;
}

.omni-channel {
    background-color: #900a39;;
    padding: 2rem 0;
}

.omni-channel-text h3 {
    color: #fff;
    line-height: 31px;
    font-size: 1.5rem;
}

ul {
    list-style: none;
    padding: 0;
    font-size: 0.9rem;
    margin: 1.5rem 0;
    line-height: 26px;
}

.omni-channel-sample ul {
    color: #fff;
}

.omni-channel-text-col {
    width: 60%;
}


.omni-channel-image img {
    width: 100%;
}

.omni-btn button{
    background-color: #fff;
    color:  #900a39;;
}

/* Online giving Section */

.online-giving {
    display: flex;
    align-items: center;
    gap: 20px;
}


.giv-2 {
    align-self: flex-end;
    z-index: 1;
    margin-right: -120px;
    padding-bottom: 1rem;
    width: 90%;
}

/* Customize pos section */
.cus-pos {
    display: flex;
    justify-content: space-between;
    gap: 90px;
}

/* footer section  */

footer {
    background-color: #ffffff;
    /* height: 100px; */
    width: 100%;
}

@media screen and (max-width: 768px) {
  .toggle {
    display: block;
  }
  .div-none{
    display: none;
  }

  
}

@media (max-width:878px) {

    .hero {
        height: 100%;
    }
    .container {
        flex-wrap: wrap;
        justify-content: center;
    }

    .col-text {
        justify-content: center;
        align-items: center;
    }

    .col-text-holder, .col-logo {
        text-align: center;
    }

    .church-logos {
        justify-content: center;
    }

    .col-image, .col-text, .omni-channel-text-col{
        width: 100%;
    }

    .header-text {
        margin: 4em 1em;
    }

    .header-text h3 {
        font-size: 1.5rem;
    }

    .header-text p {
        width: 100%;
    }

    .card1 {
        gap: 50px;
        width: 90%;
    }

    /* church website section */

    .church-website, .omni-channel-col {
        flex-wrap: wrap;
        justify-content: center;
        width: 90%;
    }

    .website {
        width: 130px;
    }

    .website-sample, .mobile-app-sample {
    justify-content: center;
    }

    .website-text, .web-btn, .mobile-app-text, .mobile-app-btn{
        text-align: center;
        padding: 0;
    }


    /* Online giving section */
    .giv-2 {
        padding-bottom: 1rem;
        width: 60%;
    }

    .giv-1 {
        width: 100%;
    }

    .online-giving-btn {
        text-align: left;
    }
}
</style>